import { OrdersIntentionsData } from '@interfaces/analysis/orders-intentions-for-approval/orders-intentions-data';
import { TitleGroupComponent } from 'components/title/title-group-component';
import { Button, Card, Col, Form, Row, Table } from 'react-bootstrap';
import '../../style/analysis/orders-intentions-for-approval.css';
import { OrdersIntentionsAccordion } from './components/orders-intentions-accordion';
import { BsSearch } from 'react-icons/bs';
import { useOrderIntentionsLists } from 'data/context/analysis/orders-intetions-lists-context';
import { Footer } from 'components/footer/footer-component';

interface Props {
  findOrdersIntentionsList: (initDate: string, endDate: string) => void;
  findOrderItemsAnalytical: (numeroPedido: number) => Promise<any>;
  findOrderItemsSynthetic: (numeroPedido: number, idSolicitante: number) => Promise<any>;
  findIntentionItensCampaign: (idIntencao: number) => Promise<any>;
  downloadOrderAnalytical: (orderNumber: number) => Promise<any>;
  downloadOrderSynthetic: (orderNumber: number) => Promise<any>;
  downloadIntention: (idIntencao: number) => Promise<any>;
  analyticalDataList: OrdersIntentionsData[];
  syntheticDataList: OrdersIntentionsData[];
  activeCampaignDataList: OrdersIntentionsData[];
}

export const OrdersItensionsForApprovalPage: React.FC<Props> = ({
  findOrdersIntentionsList,
  findOrderItemsAnalytical,
  findOrderItemsSynthetic,
  findIntentionItensCampaign,
  downloadOrderAnalytical,
  downloadOrderSynthetic,
  downloadIntention,
  analyticalDataList,
  syntheticDataList,
  activeCampaignDataList,
}) => {
  const { dataInicio, setDataInicio, dataFim, setDataFim } = useOrderIntentionsLists();

  const titlePage = 'Pedidos';

  return (
    <>
      <div>
        <div className="mx-5">
          <TitleGroupComponent titlePage={titlePage}>
            <Row></Row>
          </TitleGroupComponent>
          <div className="mx-3">
            <>
              <Card>
                <Card.Body>
                  <Row>
                    <Col md={4}>
                      <Form.Group controlId="dataInicio" style={{ display: 'flex' }}>
                        <Form.Label style={{ width: '35%', alignContent: 'center' }}>Data Inicio:</Form.Label>
                        <Form.Control type="date" value={dataInicio ?? ''} onChange={(e) => setDataInicio(e.target.value)} />
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group controlId="dataFim" style={{ display: 'flex' }}>
                        <Form.Label style={{ width: '35%', alignContent: 'center' }}>Data Fim:</Form.Label>
                        <Form.Control type="date" value={dataFim ?? ''} onChange={(e) => setDataFim(e.target.value)} />
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Button className="ms-1" variant="primary" onClick={() => findOrdersIntentionsList(dataInicio, dataFim)}>
                        Filtrar <BsSearch />
                      </Button>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: '10px', borderBottom: '1px solid #6C757D' }}></Row>
                  <Row className="mt-3">
                    <OrdersIntentionsAccordion
                      title="Analítico"
                      emptyLabel="Sem Pedidos para aprovação"
                      isOrder={true}
                      ordersIntentionsDataList={analyticalDataList}
                      viewActionFunction={findOrderItemsAnalytical}
                      downloadOrderActionFunction={downloadOrderAnalytical}
                    />
                  </Row>
                  <Row className="mt-3">
                    <OrdersIntentionsAccordion
                      title="Sintético"
                      emptyLabel="Sem Pedidos para aprovação"
                      isOrder={true}
                      ordersIntentionsDataList={syntheticDataList}
                      viewActionFunction={findOrderItemsSynthetic}
                      downloadOrderActionFunction={downloadOrderSynthetic}
                    />
                  </Row>
                  <Row className="mt-3">
                    <OrdersIntentionsAccordion
                      title="Campanhas"
                      emptyLabel="Sem Inteções para aprovação"
                      isOrder={false}
                      ordersIntentionsDataList={activeCampaignDataList}
                      viewActionFunction={findIntentionItensCampaign}
                      downloadOrderActionFunction={downloadIntention}
                    />
                  </Row>
                </Card.Body>
              </Card>
            </>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
